import { inject } from '@angular/core';
import { Router, type UrlTree } from '@angular/router';
import { UNSAVED_CHANGES_ACCEPTED } from '@quipex/core/primitives';
import type { Observable } from 'rxjs';
import { UserBuildingStore } from '../user-building/user-building.store';

export type CanBlockUnsavedChangesResult =
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree;

export interface CanBlockUnsavedChanges {
    hasUnsavedChanges: () => boolean;
}

export function resolveUnsavedChangesCanDeactivate(
    component: CanBlockUnsavedChanges,
    whenUnsavedChanges: () => CanBlockUnsavedChangesResult
): CanBlockUnsavedChangesResult {
    if (!component.hasUnsavedChanges()) {
        return true;
    }

    return whenUnsavedChanges();
}

export function resolveBuildingUnsavedChangesCanDeactivate(
    component: CanBlockUnsavedChanges | null,
    whenUnsavedChanges: () => CanBlockUnsavedChangesResult
): CanBlockUnsavedChangesResult {
    const store = inject(UserBuildingStore, { optional: true });
    if (store?.accessLost()) {
        if (component?.hasUnsavedChanges())
            store.discardUnsavedChangesAfterAccessLoss();
        return true;
    }
    if (
        inject(Router, { optional: true })?.currentNavigation?.()?.extras
            .info === UNSAVED_CHANGES_ACCEPTED
    )
        return true;
    return component
        ? resolveUnsavedChangesCanDeactivate(component, whenUnsavedChanges)
        : true;
}
